import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/application-store';
import { filter, takeUntil } from 'rxjs';
import * as userSettingsSelectors from '../../../user-settings/selectors/user-settings';
import { PreviewModeService } from '../../services/preview-mode.service';
import * as userSettingsActions from '../../../user-settings/actions/user-settings';
import {OverviewService} from "@feature/overview";
import {emptyEntityKey} from "@pma-entity/pma-entity-types";
import { OnDestroySubject } from '@common/components/on-destroy-subject';

/**
 * Appears when in PreviewMode and Triggers exit from preview mode when clicked
 **/
@Component({
  selector: 'mojo-preview-mode-exit',
  templateUrl: './preview-mode-exit.html'
})
export class PreviewModeExitComponent
  extends OnDestroySubject {

  inPreviewMode: boolean;
  isInMyDashboardMode: boolean;
  isExiting = false;

  constructor(
    private store: Store<ApplicationState>,
    private previewModeService: PreviewModeService,
    private router: Router,
    private readonly overviewService: OverviewService) {

    super();

    this.store
      .pipe(
        takeUntil(this.destroy$),
        select(userSettingsSelectors.getUserSettings),
        filter((userSettings) => userSettings != undefined),
      ).subscribe(settings => {
        this.inPreviewMode = settings.IsInPreviewMode;
        this.isInMyDashboardMode = settings.IsInMyDashboardMode;
      });

  }

  exitPreview(evt: Event) {
    if (this.isExiting) return;
    this.isExiting = true;
    this.previewModeService.exitPreviewMode().pipe(
      takeUntil(this.destroy$),
    ).subscribe((result) => {
      if (result) {
        this.store.dispatch(new userSettingsActions.Load());
        this.overviewService.loadOverview(emptyEntityKey);
        this.overviewService.loadOverviewConfiguration();
        this.router.navigated = false;
        const url = '/main';
        this.router.navigate([], { skipLocationChange: true }).then(() => {
          this.isExiting = false;
          this.router.navigate([url]);
        })
      }
    });
  }

}
